export class Errors {
  errors: any;
}
